import { theme } from '@dojo/framework/core/mixins/Themed';
import { w } from '@dojo/framework/core/vdom';
import { DNode } from '@dojo/framework/core/interfaces';
import { Messages } from '@dojo/framework/i18n/i18n';

import { I18nThemed } from 'interfaces/mixins';
import { keymap, pathmap } from 'lcc-state';

import css from '../css/related-topics.m.css';

export interface RelatedTopicProperties {
	topicid: string;
	localizedBundle: { isPlaceholder: boolean; format: object | null; messages: Messages };
}

@theme(css)
export class RelatedTopic extends I18nThemed<RelatedTopicProperties> {
	protected render(): DNode {
		const {
			topicid,
			localizedBundle: { messages }
		} = this.properties;
		const km = keymap.get(topicid)!;
		const pm = pathmap.get(km.path)!;
		const { topicref: topic } = pm.topic;

		return w('TopicRef', { topic, messages, showShort: true });
	}
}
